// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iQ1rj","tab":"styles_tab__4ZASF","label":"styles_label__BkcUl","selectedLabel":"styles_selectedLabel__UDAJk"};